export const campaignLayoutSection = {
  showSideBarSection: 'showSideBarSection',
  showListSection: 'showListSection',
  showDetailsSection: 'showDetailsSection',
};
